import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Form, Panel, Col } from 'rsuite';
import { ButtonFullBlue } from '~/components/Buttons/ButtonFullBlue/styles';
import CampoSenha from '~/components/CampoSenha';
import { ResponsiveForm } from '~/components/ResponsiveForm';
import api from '~/services/api';
import history from '~/services/history';
import { senhaAtualizada } from '~/store/modulos/autenticacao/actions';
import { mensagemSenhaFraca, REGRA_SENHA_FORTE } from '~/utils/senhaForte';

export default function Usuario() {
  const dispatch = useDispatch();
  const loggeduser = useSelector((state) => state.setUser.data);
  const senhaExpirada = useSelector((state) => state.autenticacao.senhaExpirada);
  const [senhaAtual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');

  async function editarSenha() {
    const erroSenha = mensagemSenhaFraca(novaSenha);

    if (erroSenha) {
      toast.error(erroSenha);
      return;
    }

    try {
      const resposta = await api.put(`/adm/update/${loggeduser.id}`, {
        novaSenha,
        senhaAtual,
      });

      toast.success('Senha alterada com sucesso!');
      setSenhaAtual('');
      setNovaSenha('');

      if (resposta.data.token) {
        api.defaults.headers.Authorization = `Bearer ${resposta.data.token}`;
        localStorage.setItem('token-login', resposta.data.token);
        dispatch(senhaAtualizada(resposta.data.token));
        history.push('/home');
      }
    } catch (err) {
      toast.error(err.message);
    }
  }

  return loggeduser ? (
    <Panel header={<h3>Dados do Usuário</h3>} style={{ width: '100%' }}>
      {senhaExpirada && (
        <p style={{ marginBottom: 16 }}>
          Sua senha expirou. Defina uma nova senha para continuar usando o portal.
        </p>
      )}
      <Form>
        <Col md={12} xs={24} sm={24}>
          <ResponsiveForm
            placeholder="Nome Completo"
            name="nome"
            type="text"
            label="Nome"
            value={loggeduser.nome}
            disabled
          />
        </Col>
        <Col md={12} xs={24} sm={24}>
          <ResponsiveForm
            placeholder="Email"
            name="email"
            type="email"
            label="Email"
            value={loggeduser.email}
            disabled
          />
        </Col>
        <Col md={12} xs={24} sm={24}>
          <CampoSenha
            label="Senha atual"
            value={senhaAtual}
            onChange={(valor) => setSenhaAtual(valor)}
            name="senha-atual"
          />
        </Col>
        <Col md={12} xs={24} sm={24}>
          <CampoSenha
            label="Nova senha"
            value={novaSenha}
            onChange={(valor) => setNovaSenha(valor)}
            name="senha"
          />
          <p style={{ marginTop: 8, color: '#575757' }}>{REGRA_SENHA_FORTE}</p>
        </Col>
        <ButtonFullBlue
          disabled={!(senhaAtual !== '' && novaSenha !== '')}
          appearance="primary"
          onClick={() => editarSenha()}
        >
          Editar Senha
        </ButtonFullBlue>
      </Form>
    </Panel>
  ) : (
    <h1>Carregando...</h1>
  );
}
